export default class History{
    constructor(){
        this.histories = document.querySelectorAll('.history');
        if (this.histories){
            this.init(); 
        }
    }
    
    init() {
        let observer = new IntersectionObserver(
            (entries, observer) => { 
                entries.forEach(entry => {
                    /* Placeholder replacement */
                    if (entry.isIntersecting) {
                    entry.target.classList.add('intersecting');
                    observer.unobserve(entry.target);
                    }
                });
            },
            {rootMargin: "0px 0px -40% 0px", threshold: 0}
        );

        this.histories.forEach(history => {
            observer.observe(history);
        });
    }
}